"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userCompanyMock = void 0;
const userCompanyMock = (userCompany) => ({
    accountOwnerEmail: 'john_doe@gmail.com',
    address: 'My address',
    carrierId: 'a7e340d0-18e8-48db-b034-c2a06a440a61',
    carrierType: 'CARRIER',
    cpsCarrierId: '123cps',
    companyCarrierTier: 1,
    companyIsInVettingProcess: false,
    contact: 'John Doe',
    germanVatId: 'GE123456',
    isCarrier: true,
    name: 'Test Company',
    vatId: 'GE3335526262',
    ...userCompany
});
exports.userCompanyMock = userCompanyMock;
